var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suspension"},[(_vm.btnFlag)?_c('div',{staticClass:"backtop",on:{"click":_vm.backtop}},[_c('i',{staticClass:"el-icon-caret-top"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }